import defaultReducer from "@/redux/modules/default.reducer";
import { TApiAction } from "@/redux/store.types";

const discriminatorReducer = (
    state: any,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any
) => {
    const { type, payload, actionOptions = {} } = action;

    if (!actionOptions.discriminator) {
        return state;
    }

    let newState = { ...state };

    if (type === constants.RESET) {
        newState = {
            ...initialState,
            [actionOptions.discriminator]: {}
        };
    }

    if (type === constants.PENDING) {
        newState = {
            ...state,
            [actionOptions.discriminator]: {
                ...state[actionOptions.discriminator!],
                params: payload,
                loading: true,
                error: null
            },
            data: options.clearOnFetch ? null : state.data
        };
    }

    const skipSuccessData = actionOptions?.skipSuccessData
        ? actionOptions.skipSuccessData()
        : false;

    if (type === constants.SUCCESS) {
        newState = {
            ...state,
            [actionOptions.discriminator]: {
                ...state[actionOptions.discriminator!],
                loading: false,
                error: null
            },
            data: skipSuccessData ? state.data : payload
        };
    }

    if (type === constants.FAILURE) {
        newState = {
            ...state,
            [actionOptions.discriminator]: {
                ...state[actionOptions.discriminator!],
                loading: false,
                error: payload
            },

            data: options.clearOnError ? null : state.data
        };
    }

    return newState;
};

const CartReducer = (
    state: any,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any
) => {
    const { actionOptions = {} } = action;

    const hasDiscriminator = !!actionOptions?.discriminator;

    return hasDiscriminator
        ? discriminatorReducer(state, action, constants, options, initialState)
        : defaultReducer(state, action, constants, options, initialState);
};

export default CartReducer;
